import React, { useState } from "react";
import { UseGlobellogin } from "./Logincontaxt.jsx/Logincontex";
import ReCAPTCHA from "react-google-recaptcha";
import Forgetpassword from "../Forgetpassword";
import { BASE_URL } from "../Config/Config";
import GoogleSignin from "./Googlesignup";
import { RECAPTCHA_SITE_KEY } from "./GlobelHelper/GlobelRechpcha";
import { NavLink , useNavigate  , useLocation} from "react-router-dom";
import SubLoading from "../ALL CSS/Loading";
import styled from "styled-components";

const Login = ({ handleClose, setIsSignin }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formMessage, setFormMessage] = useState("");
  const [Enable, setEnable] = useState(true);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const { storeToken, setsuccessfully , seterrormessage } = UseGlobellogin();
  const [Loading, setLoading] = useState(false);
  const [data, setData] = useState({
    user_input: "",
    password: "",
  });

const from = location.state?.from?.pathname || "/";


  function onChange(value) {
    setEnable(false);
  }

  const updateInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setData({ ...data, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();
   const userInput = data.user_input.trim();
let loginMethod = "";

if (/^\d{10}$/.test(userInput)) {
  // mobile number
  loginMethod = "mobile";
} else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userInput)) {
  // email
  loginMethod = "email";
}

    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/login/`, {
        method: "post",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      if (response.ok) {
        setsuccessfully(responseData.message);
        setTimeout(() => setsuccessfully(""), 7000);
        localStorage.setItem("serverToken", responseData.access_token);
        localStorage.setItem("user_id", responseData.user_id);
        localStorage.setItem("userEmail", data.user_input);
        localStorage.setItem("login_method", loginMethod);
        window.dispatchEvent(new Event("storage"));

        storeToken();
        setData({ user_input: "", password: "" });
        if(from){
          navigate(from);
        }
        else{
          navigate("/")
        }

      } else {
        setFormMessage(responseData.message);
        seterrormessage(responseData.message)
      }
    } catch (error) {
      seterrormessage(error);
      
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <Wrappaer >
    <section className=" auth-section auth-fullscreen">
      <div className=" p-0">
        <div className="row ">
          <div className="col-12 text-center p-0">
            <h4 className="display-5 fw-bold p-0">
              {isForgotPassword ? "Forgot Password" : "Login"}
            </h4>
            
            <div className="text-center mb-4 px-4">
        <p className="d-none d-sm-block d-block  text-lg font-semibold text-gray-800 leading-snug text-primary">
    Welcome to <span className="text-indigo-600 font-bold">Auratech</span> — your gateway to smart learning & seamless tech solutions. Let’s grow together!
  </p>
            {!isForgotPassword && (
              <p>
                Don’t have an account?{" "}

                <span
                  className="text-primary cursor-pointer"
                  onClick={() => setIsSignin(true)}
                  style={{ cursor: "pointer", fontWeight: 700 }}
                >
                  Sign Up
                </span>
              </p>
            )}
            </div>
          </div>
        </div>

        <div className="row justify-content-center g-0  ">
          <div className="col-12 col-lg-10 col-xl-10 ">
            <div className="row align-items-stretch g-0">

              {isForgotPassword ? (
                
                  <Forgetpassword setIsForgotPassword={setIsForgotPassword} />
              ) : (
                <>

                  <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                      <div className="login-card p-4 p-md-5 h-100 d-flex flex-column justify-content-center">
                    <form onSubmit={submitForm}>

                      <div className="form-floating mb-3">
                        <input
                          type="text"
                          className="form-control"
                          name="user_input"
                          id="user_input"
                          placeholder="Email"
                          value={data.user_input}
                          onChange={updateInput}
                          required
                        />
                        <label htmlFor="user_input">Email</label>
                      </div>

                      <div className="form-floating mb-3">
                        <input
                          type="password"
                          className="form-control "
                          name="password"
                          id="password"
                          placeholder="Password"
                          value={data.password}
                          onChange={updateInput}
                          required
                        />
                        <label htmlFor="password">Password</label>
                      </div>

                      <div
                        className="text-start text-primary mb-2"
                        style={{ cursor: "pointer" }}
                        onClick={() => setIsForgotPassword(true)}
                      >
                        Forgot Password?
                      </div>

                      {formMessage && (
                        <div className="text-danger fw-bold mb-3">{formMessage}</div>
                      )}

                      <div className="mb-3 d-flex justify-content-start">
                        <div style={{ transform: "scale(0.70)", transformOrigin: "0 0" }}>
                          <ReCAPTCHA
                            sitekey={RECAPTCHA_SITE_KEY}
                            onChange={onChange}
                          />
                        </div>
                      </div>


                      {/* <div className="d-grid"> */}
                        <div className="btn-group d-grid">
                          <button
                            type="submit"
                            className="th-btn style3"

                            disabled={Enable}>
                            {
                              Loading ? (<>
                                <div className="d-flex align-items-center gap-2">
                                  <span>Loading...</span>
                                  <SubLoading />
                                </div>

                              </>) : (
                                <>
                                  Log In <i className="fas fa-arrow-right ms-2" />
                                </>
                              )
                            }
                          </button>
                        </div>
                      {/* </div> */}
                    </form>
                  </div>
                  
                  </div>


                <div className="col-12 col-lg-1 d-flex flex-column align-items-center justify-content-center my-3 my-lg-0">
        <div className="d-lg-block d-none bg-dark" style={{ width: 1, height: "100%", opacity: 0.1 }} />
        <div className="d-lg-none d-block bg-dark" style={{ width: "100%", height: 1, opacity: 0.1 }} />
        <span className="my-2">or</span>
        <div className="d-lg-block d-none bg-dark" style={{ width: 1, height: "100%", opacity: 0.1 }} />
        <div className="d-lg-none d-block bg-dark" style={{ width: "100%", height: 1, opacity: 0.1 }} />
      </div>

                  <div className="col-12 col-lg-4">
                    
                    <div className="sigin-card d-flex flex-column align-items-center justify-content-evenly h-100 ">
                      <div className="mobile-logo">
                        <NavLink to="/"><img src="/assets/img/AA_LOgo_Black.png" alt="Auratech Academy"style={{ maxWidth: "100%", height: "auto" }} /></NavLink>
                      </div>
                      <GoogleSignin mode="login" handleClose={handleClose} />
                     
                    </div>
                  </div>

                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
    </Wrappaer>
  );
};

const Wrappaer = styled.section`
  .auth-section {
    // min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    // background-color: #f4f7fa; 
  }

  .login-card {
    transition: all 0.5s ease-in-out;
    border: 1px solid #b3cae0ff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    background-color: #ffffff;
    border-radius: 12px;
  }

  .login-card:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    transform: translateY(-8px);
  }

  .login-card input:focus {
    border-color: #0d6efd;
    box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
  }

  .login-card .th-btn {
    transition: background-color 0.4s ease, transform 0.3s;
  }

  .login-card .th-btn:hover {
    background-color: #084298;
    transform: translateY(-2px);
  }

  .sigin-card {
    padding: 1rem;
  }

  @media (max-width: 768px) {
    .login-card,
    .sigin-card {
      padding: 1.5rem;
    }

    .auth-section h4 {
      font-size: 1.8rem;
    }

    .text-lg {
      font-size: 1rem;
    }

    .btn-group {
      flex-direction: column;
    }

    .mobile-logo {
      display: block;
      text-align: center;
      margin-top: 2rem;
    }
  }
`;




export default Login;
